function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.8309,
  cy: 18.4917,
  r: 15,
  transform: "rotate(-12.199 17.8309 18.4917)",
  fill: "#403D3A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 9.99951L18.5 16.5055L23.9989 18.9626L18.5 9.99951Z",
  fill: "white",
  fillOpacity: 0.602
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4996 9.99951L13 18.9626L18.4996 16.5055L18.4996 9.99951Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 23.1789L18.5 27.5996L24.0025 19.9868L18.5 23.1789Z",
  fill: "white",
  fillOpacity: 0.602
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4996 27.5996L18.4996 23.1782L13 19.9868L18.4996 27.5996Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 22.1553L23.9989 18.9625L18.5 16.5068L18.5 22.1553Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13 18.9625L18.4996 22.1553L18.4996 16.5068L13 18.9625Z",
  fill: "white",
  fillOpacity: 0.602
});

var SvgBit1 = function SvgBit1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBit1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bit1.c05e3b20.svg";
export { ForwardRef as ReactComponent };